/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.application', [])
    .factory('applicationService', ApplicationService)
    .name;

/*@ngInject*/
function ApplicationService($http, $q) {

    var service = {
        deleteApplication: deleteApplication,
        getApplication: getApplication,
        getSystemApplication: getSystemApplication,
        saveApplication: saveApplication,
        getCustomerApplications: getCustomerApplications,
        getSubCustomerApplications: getSubCustomerApplications,
        assignApplicationToSubCustomer: assignApplicationToSubCustomer,
        unassignApplicationFromSubCustomer: unassignApplicationFromSubCustomer,
        saveAlarmRules: saveAlarmRules
    }

    return service;

    function getCustomerApplications () {
        var deferred = $q.defer();
        $http.get('/api/customer/applications', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSubCustomerApplications (subCustomerId) {
        var deferred = $q.defer();
        $http.get(`/api/subCustomer/${subCustomerId}/applications`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getApplication (applicationId) {
        var deferred = $q.defer();
        var url = '/api/application/' + applicationId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSystemApplication (applicationId) {
        var deferred = $q.defer();
        var url = '/api/system/application/' + applicationId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveAlarmRules (applicationId, alarmRules) {
        var deferred = $q.defer();
        var url = `/api/application/${applicationId}/alarmRules`;
        $http.post(url, alarmRules).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveApplication (application) {
        var deferred = $q.defer();
        var url = '/api/application';
        $http.post(url, application).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteApplication (applicationId) {
        var deferred = $q.defer();
        var url = '/api/application/' + applicationId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function assignApplicationToSubCustomer(subCustomerId, applicationId) {
        var deferred = $q.defer();
        var url = `/api/subCustomer/${subCustomerId}/application/${applicationId}`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function unassignApplicationFromSubCustomer(applicationId) {
        var deferred = $q.defer();
        var url = `/api/subCustomer/application/${applicationId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/application.service.js